import React from 'react'
import './IdContactPropt.css'

function IdContactPropt({Photo , Header , Text , IsLink, Link}) {
  var TextVar;
  if(IsLink)
    TextVar = <a id='Propt-Text-Link' href={Link} target='_blank' rel="noopener noreferrer">{Text}</a>
  else
    TextVar = <p id='Propt-Text'>{Text}</p>
    return (
      <div id='Id-Propt'>
        <img src={Photo} id='Propt-Photo' alt=""/>
        <div id='Propt-Main' translate='no'>
          <p id='Propt-Header'>{Header}</p>
          {TextVar}
        </div>
      </div>
    )
  }

export default IdContactPropt
